export default __webpack_public_path__ + "static/media/ccqarmenia.e60b6a82.jpg";